export * from './getBoundsRectangle'
export * from './transformRectangle'
export * from './transformSingleRectangle'
export * from './TextAreaUtils'
export * from './shape-styles'
export * from './getTextAlign'
export * from './getTextSvgElement'



// WEBPACK FOOTER //
// ./src/modules/whiteboard/shapes/shared/index.ts